// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.neon-text {
  color: #b5ff5a;
  text-shadow:
    0 0 12px #39ff14,
    0 0 25px #39ff14,
    0 0 50px #39ff1e,
    0 0 80px #39ff1e55;
}

.neon-logo {
  filter: drop-shadow(0 0 6px #39ff14) drop-shadow(0 0 14px #39ff1477);
}

.album-card {
  border: 2px solid rgba(57,255,20,0.2);
  box-shadow:
    0 0 15px rgba(57,255,20,0.3),
    0 0 30px rgba(57,255,20,0.2);
  transition: 0.3s ease;
}

.album-card:hover {
  box-shadow:
    0 0 30px rgba(57,255,20,0.9),
    0 0 60px rgba(57,255,20,0.6);
}

.album-img {
  transition: 0.4s ease;
}

.album-card:hover .album-img {
  transform: scale(1.1);
  filter: brightness(1.25);
}

.album-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent, rgba(0,0,0,0.75));
  opacity: 0;
  transition: 0.4s ease;
}

.album-card:hover .album-overlay {
  opacity: 1;
}

.neon-img {
  box-shadow:
    0 0 30px #39ff1488,
    0 0 60px #39ff1444;
  border-radius: 16px;
}

.neon-circle {
  position: absolute;
  width: 900px;
  height: 900px;
  background: radial-gradient(circle, #39ff14aa, transparent 70%);
  top: -200px;
  left: -200px;
  filter: blur(110px);
  opacity: 0.35;
}
`, "",{"version":3,"sources":["webpack://./src/pages/gallery.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd;;;;sBAIoB;AACtB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,qCAAqC;EACrC;;gCAE8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE;;gCAE8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kEAAkE;EAClE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;;sBAEoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,+DAA+D;EAC/D,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".neon-text {\n  color: #b5ff5a;\n  text-shadow:\n    0 0 12px #39ff14,\n    0 0 25px #39ff14,\n    0 0 50px #39ff1e,\n    0 0 80px #39ff1e55;\n}\n\n.neon-logo {\n  filter: drop-shadow(0 0 6px #39ff14) drop-shadow(0 0 14px #39ff1477);\n}\n\n.album-card {\n  border: 2px solid rgba(57,255,20,0.2);\n  box-shadow:\n    0 0 15px rgba(57,255,20,0.3),\n    0 0 30px rgba(57,255,20,0.2);\n  transition: 0.3s ease;\n}\n\n.album-card:hover {\n  box-shadow:\n    0 0 30px rgba(57,255,20,0.9),\n    0 0 60px rgba(57,255,20,0.6);\n}\n\n.album-img {\n  transition: 0.4s ease;\n}\n\n.album-card:hover .album-img {\n  transform: scale(1.1);\n  filter: brightness(1.25);\n}\n\n.album-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, transparent, rgba(0,0,0,0.75));\n  opacity: 0;\n  transition: 0.4s ease;\n}\n\n.album-card:hover .album-overlay {\n  opacity: 1;\n}\n\n.neon-img {\n  box-shadow:\n    0 0 30px #39ff1488,\n    0 0 60px #39ff1444;\n  border-radius: 16px;\n}\n\n.neon-circle {\n  position: absolute;\n  width: 900px;\n  height: 900px;\n  background: radial-gradient(circle, #39ff14aa, transparent 70%);\n  top: -200px;\n  left: -200px;\n  filter: blur(110px);\n  opacity: 0.35;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
